import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navigation.css';


const canManageOperations = (role) => ['admin', 'manager', 'supervisor'].includes(role);
const canAdjustHours = (role) => ['admin', 'supervisor'].includes(role);

const Navigation = ({ user }) => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    setMobileMenuOpen(false);
    setOpenDropdown(null);
  }, [location.pathname]);

  const closeMobileMenu = (event) => {
    setMobileMenuOpen(false);
    setOpenDropdown(null);
    if (event?.currentTarget?.blur) {
      event.currentTarget.blur();
    }
  };

  const openMenuDropdown = (dropdownName) => {
    setOpenDropdown(dropdownName);
  };

  const closeMenuDropdown = () => {
    setOpenDropdown(null);
  };

  const handleDropdownBlur = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      closeMenuDropdown();
    }
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  // Safety check for user
  if (!user) {
    return null;
  }


  return (
    <nav className="navigation">
      <button
        type="button"
        className="nav-toggle"
        aria-expanded={mobileMenuOpen}
        aria-controls="primary-navigation"
        onClick={() => setMobileMenuOpen((open) => !open)}
      >
        <span className="nav-toggle-icon" aria-hidden="true">☰</span>
        Menu
      </button>

      <div
        id="primary-navigation"
        className={`nav-container ${mobileMenuOpen ? 'mobile-open' : ''}`}
      >
        <Link 
          to="/dashboard" 
          className={`nav-link ${isActive('/') || isActive('/dashboard') ? 'active' : ''}`}
          onClick={closeMobileMenu}
        >
          Úvod
        </Link>

        {user.role === 'admin' ? (
          <div
            className={`nav-dropdown ${openDropdown === 'users' ? 'open' : ''}`}
            onMouseEnter={() => openMenuDropdown('users')}
            onMouseLeave={closeMenuDropdown}
            onFocus={() => openMenuDropdown('users')}
            onBlur={handleDropdownBlur}
          >
            <Link 
              to="/users" 
              className={`nav-link ${isActive('/users') ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              Používatelia
            </Link>
            <div className="dropdown-content">
              <Link to="/admin/terms" className="dropdown-item" onClick={closeMobileMenu}>
                Správa podmienok
              </Link>
              <Link to="/admin/audit-log" className="dropdown-item" onClick={closeMobileMenu}>
                Audit log
              </Link>
            </div>
          </div>
        ) : (
          <Link 
            to={`/users/${user.id}`}
            className={`nav-link ${location.pathname.startsWith('/users/') ? 'active' : ''}`}
            onClick={closeMobileMenu}
          >
            Môj profil
          </Link>
        )}

        {canManageOperations(user.role) && (
          <Link 
            to="/projects" 
            className={`nav-link ${isActive('/projects') ? 'active' : ''}`}
            onClick={closeMobileMenu}
          >
            Projekty
          </Link>
        )}

        <Link 
          to="/attendance" 
          className={`nav-link ${isActive('/attendance') ? 'active' : ''}`}
          onClick={closeMobileMenu}
        >
          Dochádzka
        </Link>

        <Link 
          to="/vacation-requests" 
          className={`nav-link ${isActive('/vacation-requests') ? 'active' : ''}`}
          onClick={closeMobileMenu}
        >
          Voľno
        </Link>

        {user.role === 'admin' && (
          <Link 
            to="/statistics" 
            className={`nav-link ${isActive('/statistics') ? 'active' : ''}`}
            onClick={closeMobileMenu}
          >
            Štatistiky
          </Link>
        )}

        {canAdjustHours(user.role) && (
          <Link 
            to="/hours-adjustment" 
            className={`nav-link ${isActive('/hours-adjustment') ? 'active' : ''}`}
            onClick={closeMobileMenu}
          >
            Úprava hodín
          </Link>
        )}

        {canAdjustHours(user.role) && (
          <Link 
            to="/hours-import" 
            className={`nav-link ${isActive('/hours-import') ? 'active' : ''}`}
            onClick={closeMobileMenu}
          >
            Import hodín
          </Link>
        )}

        {canAdjustHours(user.role) ? (
          <div
            className={`nav-dropdown ${openDropdown === 'documents' ? 'open' : ''}`}
            onMouseEnter={() => openMenuDropdown('documents')}
            onMouseLeave={closeMenuDropdown}
            onFocus={() => openMenuDropdown('documents')}
            onBlur={handleDropdownBlur}
          >
            <Link 
              to="/documents" 
              className={`nav-link ${isActive('/documents') ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              Dokumenty
            </Link>
            <div className="dropdown-content">
              <Link to="/work-report" className="dropdown-item" onClick={closeMobileMenu}>
                Pracovný výkaz
              </Link>
            </div>
          </div>
        ) : (
          <Link
            to="/documents"
            className={`nav-link ${isActive('/documents') ? 'active' : ''}`}
            onClick={closeMobileMenu}
          >
            Moje dokumenty
          </Link>
        )}

      </div>
    </nav>
  );
};

export default Navigation;
